import axios from 'axios'
import moment from 'moment'

import API from '@/services/API'
import Utils from '@/services/utils'


export default{
    reports: {

    },

    resourcesByReport:{

    },

    dlAlertRecord(alertId,filename){
        return new Promise((resolve,reject)=>{
            var route = API.endpoints.reports.alertrecord;
            var outputFormat = 'pdf'


            var params = {
                alertId: alertId,
                reportPeriod: moment().format('YYYY-MM-DD') + ' ' + '00:00:00' + ',' + moment().format('YYYY-MM-DD') + ' ' + '23:59:59'
            }

            axios({
              method: 'post',
              url: '/beepiz/reports',
              responseType: 'blob',
              data: {
                'reportSlug': 'alertrecord',
                'resourceType': 'alert' + '-' + params.alertId,
                'dates': params.reportPeriod,
                'timezone': moment.tz.guess()
              },
              headers: {
                'Accept': Utils.getMimeFromOutput(outputFormat)
              }
            })
                .then(response => {
                    // It is necessary to create a new blob object with mime-type explicitly set
                    // otherwise only Chrome works like it should
                    var newBlob = new Blob([response.data], {type: Utils.getMimeFromOutput(outputFormat)})

                    // IE doesn't allow using a blob object directly as link href
                    // instead it is necessary to use msSaveOrOpenBlob
                    if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                        window.navigator.msSaveOrOpenBlob(newBlob, filename + "." + outputFormat);
                        resolve()
                        return;
                    }

                    // For other browsers:
                    // Create a link pointing to the ObjectURL containing the blob.
                    const data = window.URL.createObjectURL(newBlob);
                    var link = document.createElement('a');
                    document.body.appendChild(link);
                    link.href = data;
                    link.download = filename + "." + outputFormat;
                    link.click();
                    resolve()
                    setTimeout(function () {
                        // For Firefox it is necessary to delay revoking the ObjectURL
                        window.URL.revokeObjectURL(data);
                    }, 100)
                })
                .catch(error => {
                    if (error.response.status == 422) {
                        window.Vfc.$refs.messages.sendMessage('error', window.V.$i18n.t('errors.e422') + ' ' + error.response.data.message);
                        reject()
                    }
                })
            })


    }

}
